import Sidebar from '../components/Sidebar';

export default function Eval() {
    return (
        <div className="page-container">
            <Sidebar />

            <div className="content-container">
                <h1>Eval</h1>
            </div>
        </div>
    ); 
}